import { initLocalOptionsWithDefaultOption } from '../Selectors/Option';

export const wallTypes = initLocalOptionsWithDefaultOption([
  {
    identifier: 'wall_trapezoidal',
    externalIdentifier: 'wall_trapezoidal',
    variant: 'wall_trapezoidal',
    title: 'Trapezblech',
  },
  {
    identifier: 'wall_pvc',
    externalIdentifier: 'wall_pvc',
    variant: 'wall_pvc',
    title: 'PVC wall',
  },
  {
    identifier: 'wall_sandwich_40',
    externalIdentifier: 'wall_sandwich_40',
    variant: 'wall_sandwich_40',
    thickness: 40,
    title: 'Sandwich 40 mm',
  },
  {
    identifier: 'wall_sandwich_60',
    externalIdentifier: 'wall_sandwich_60',
    variant: 'wall_sandwich_60',
    thickness: 60,
    title: 'Sandwich 60 mm',
  },
  {
    identifier: 'no_wall_cladding',
    externalIdentifier: 'no_wall_cladding',
    variant: 'no_wall_cladding',
    thickness: 0,
    title: 'No Wall Cladding',
    isDynamic: true,
  },
]);

export const defaultWallType = wallTypes[0];

export function isPVCWall(obj) {
  return obj?.identifier === 'wall_pvc';
}

export function isNoWallCladding(obj) {
  return obj?.identifier === 'no_wall_cladding';
}
